import React from "react";
// import { useMemo } from "react";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import Skeleton from "@mui/material/Skeleton";
import SearchInput from "../../../common/SearchInputField";
// import { FilterChipCloseIcon } from "../Customers/customersFilterUiShared";
// import CustomerToolbarFilterDropdown from "../Customers/CustomerToolbarFilterDropdown";

export default function TeamToolbar({
  searchQuery,
  onSearchChange,
  // groupFilters,
  // onGroupFiltersChange,
  // onClearAll,
  // groupOptions = [],
  // groupsLoading = false,
}) {
  // Group filter chips hidden for now
  // const chips = useMemo(
  //   () =>
  //     groupFilters.map((v) => {
  //       const opt = groupOptions.find((o) => o.value === v);
  //       return { key: `group-${v}`, label: opt?.label || v, value: v };
  //     }),
  //   [groupFilters, groupOptions]
  // );

  return (
    <Box sx={{ px: "24px", pt: "24px", pb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Box sx={{ width: 296, flex: "0 0 296px" }}>
          <SearchInput
            placeholder="Search teams..."
            value={searchQuery}
            className="SearchInputField-article"
            onChange={(e) => onSearchChange(e.target.value)}
            iconPosition="left"
            iconGap={8}
            style={{ width: 296 }}
            inputStyle={{ width: 296 }}
            noTitle
            iconVariant="people"
          />
        </Box>
        {/* Group filter hidden for now
        {groupsLoading ? (
          <Skeleton variant="rounded" width={136} height={40} sx={{ borderRadius: "8px", flexShrink: 0 }} />
        ) : (
          <CustomerToolbarFilterDropdown
            label="Group"
            placeholder="Search groups"
            options={groupOptions}
            selected={groupFilters}
            onChange={onGroupFiltersChange}
          />
        )}
        */}
      </Box>
      {/* Group filter chips hidden for now
      {chips.length > 0 && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            mt: 1.5,
          }}
        >
          {chips.map((chip) => (
            <Box
              key={chip.key}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.5,
                borderRadius: "20px",
                border: "1px solid #C5CED6",
                background: "#F9FAFA",
                boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#405261", fontFamily: "Inter" }}>
                {chip.label}
              </Typography>
              <Box
                component="button"
                type="button"
                onClick={() =>
                  onGroupFiltersChange(groupFilters.filter((v) => v !== chip.value))
                }
                sx={{
                  border: "none",
                  background: "transparent",
                  p: 0,
                  display: "flex",
                  cursor: "pointer",
                  lineHeight: 0,
                }}
              >
                <FilterChipCloseIcon style={{ width: 16, height: 16, display: "block" }} />
              </Box>
            </Box>
          ))}
          <Button
            onClick={onClearAll}
            sx={{
              width: 96,
              height: 32,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              color: "#405261",
              textAlign: "center",
              fontFamily: "Inter",
              fontSize: 14,
              fontWeight: 400,
              lineHeight: "normal",
              textTransform: "none",
              flexShrink: 0,
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            Clear All
          </Button>
        </Box>
      )}
      */}
    </Box>
  );
}
